export function getAuthorLinkWithId(authorId?: string) {
  if (!authorId) return '';
  return `/author/${authorId}`;
}
